Vue.component("MpMailto", {
    props: {
        address: String,
        domain: String
    },
    data: function() {
        return {

        };
    },
    computed: {
        emailAddress: function() {
            return "mailto:"+this.address+"@"+this.domain;
        }
    },
    methods: {
        linkClicked: function() {
            window.location.href = this.emailAddress;
        }
    },

    template: '\
    <a href="#" @click.prevent="linkClicked">\
        <slot></slot>\
    </a>',
});
